import axios from "axios";
import { SECONDS_IN_MINUTE, TIME_INTERVALS, TIME_INTERVALS_IN_MINUTES } from "../constants";
import { updateCifsShareExpiration} from "../../helpers/expiration-handler";

const initEditMountExpireModal = () => {
  initSaveExpireHandler();
  initCloseModalHandler();
  initSlider();
};

const initSaveExpireHandler = () => {
  document.querySelectorAll('.save-edited-expire').forEach((link) => {
    link.addEventListener('click', (e) => {
      e.preventDefault();

      const currentElement = e.currentTarget;
      const timeValue = document.querySelector('.slide-value').value * SECONDS_IN_MINUTE;
      const shareID = currentElement.dataset.shareId;

      currentElement.classList.remove('save-edited-expire');
      currentElement.classList.add('disabled');

      axios.post(`/share/set_cifs_share_ttl/${shareID}/${timeValue}`)
        .then(response => {
          const data = response.data;
          if (response.data.ok) {
            const newElement = document.querySelector(`[data-event-share="${shareId}"]`);
            if (newElement) {
              newElement.setAttribute('data-expire', response.data.newExpireTime)
            }
            updateCifsShareExpiration(1000);
          }
          document.querySelectorAll('.edit-mount-expires').forEach(modal => modal.remove());
        })
    })
  })
};

const initCloseModalHandler = () => {
  document.querySelectorAll('.closemodal').forEach( (link) => {
    link.addEventListener('click', (e) => {
      e.preventDefault();
      document.querySelectorAll('.edit-mount-expires').forEach(modal => modal.remove());
    });
  });
};

const initSlider = () => {
  const slider_data = {
    max: valMap.length - 1,
    min: 0,
    value: 5,
    slide: function(e, ui) {
      $(this).siblings('.sliderDisplay').html(TIME_INTERVALS[ui.value]);
      $(this).siblings('.slide-value').val(TIME_INTERVALS_IN_MINUTES[ui.value]);
    },
    change: function(e, ui) {
      $(this).siblings('.sliderDisplay').html(TIME_INTERVALS[ui.value]);
      $(this).siblings('.slide-value').val(TIME_INTERVALS_IN_MINUTES[ui.value]);
    }
  };

  $('#content').find('.sliderBar').slider(slider_data);
};

export { initEditMountExpireModal };
